/**
 * Toast notification helper.
 *
 * Provides simple functions to show toast notifications using react-native-toast-message.
 */

import Toast from 'react-native-toast-message';

export type ToastType = 'success' | 'error' | 'info';

/**
 * Show a toast notification.
 *
 * @param type - Type of toast (success, error, info)
 * @param message - Message to display
 */
export function showToast(type: ToastType, message: string): void {
  Toast.show({
    type: type,
    text1: type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Info',
    text2: message,
    position: 'top',
    visibilityTime: 3000,
    autoHide: true,
    topOffset: 50,
  });
}

/**
 * Show a success toast.
 */
export function showSuccess(message: string): void {
  showToast('success', message);
}

/**
 * Show an error toast.
 */
export function showError(message: string): void {
  showToast('error', message);
}

/**
 * Show an info toast.
 */
export function showInfo(message: string): void {
  showToast('info', message);
}
